import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from 'lodash';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DateRangePicker, DateRangeDelimiter } from "@material-ui/pickers";
import {
  withStyles,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import * as Var from "styles/variables";
import {
  setDateRangePicTreeNttFt,
  getHomePictreeCheckInNttFt,
  getHomePictreePhotoShootNttFt,
  getPictreeDataCheckInTrendNttFt,
  getPictreeDataPhotoShootTrendNttFt,
  getPictreeDataPhotoDenchuKaisuTrend,
  getInGameItemSalesByOccurrence,
  getPhotoShootMapDataNttFt,
  getPictreePhotoShootByAssetNttFt,
  getPictreePhotoShootTrendByAssetNttFt,
  getHomePictreeReportStats,
  getPictreeDataReportTrend,
  getPictreeDataReportByUser,
  getByAreaData,
  getBudgetSummaryData,
  getBudgetRemainTrendData,
} from "actions";
import PeriodNttFt from "components/PicTree/Filter/PeriodNttFt";

const useStyles = makeStyles((theme) =>
  createStyles({
    calendarWrapper: {
      paddingLeft: 8,
      flexGrow: 1,
    },
    root: {
      backgroundColor: "#fafafa",
      zIndex: 1000,
      paddingTop: 16,
      paddingLeft: 8,
      marginTop: -12,
    },
    container: {
      display: "flex",
      width: 300,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignItems: "baseline",
    },
    delimiter: {
      paddingTop: theme.spacing(1),
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      color: Var.btnLabelColor,
    },
    grow: {
      flexGrow: 1,
    },
    sectionCalendar: {
      display: "flex",
      marginRight: theme.spacing(1),
      alignItems: "center",
      gap: theme.spacing(0.5),
    },
    picTreePredefined: {
      marginRight: 16,
      marginTop: -16,
    }
  })
);

const CalendarRangePicTreeNttFt = ({
  page,
  singlePeriod,
  dateRangePicTreeNttFt,
  dateRangePicTreeMinMax,
  currentPage,
  getHomePictreeCheckInNttFt,
  getHomePictreePhotoShootNttFt,
  getPictreeDataCheckInTrendNttFt,
  getPictreeDataPhotoShootTrendNttFt,
  pictreeChartSize,
  getPhotoShootMapDataNttFt,
  pictreeMapType,
  setDateRangePicTreeNttFt,
  getPictreePhotoShootByAssetNttFt,
  getPictreePhotoShootTrendByAssetNttFt,
  getHomePictreeReportStats,
  getPictreeDataReportTrend,
  getPictreeDataReportByUser,
  getByAreaData,
  getBudgetSummaryData,
  getBudgetRemainTrendData,
  selectedSeason,
}) => {
  const classes = useStyles();
  const [dateRangeValue, setDateRangeValue] = useState([null, null]);
  const [error, setError] = useState([null, null]);
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);

  const today = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
  const todayFormatted = moment(today).format("YYYY-MM-DD");

  useEffect(() => {
    const currentJstDate = moment().tz("Asia/Tokyo").format("YYYY/MM/DD");
    handleHomeCalendar(currentJstDate);
  }, []);

  useEffect(() => {
    if (dateRangePicTreeMinMax.length > 0) {
      const defaultMaxDateFormatted = moment(dateRangePicTreeMinMax[1]).format('YYYY-MM-DD');
      const isEndDateAfterToday = moment(today).isBefore(defaultMaxDateFormatted);
      setMinDate(dateRangePicTreeMinMax[0]);
      setMaxDate(isEndDateAfterToday ? todayFormatted : dateRangePicTreeMinMax[1]);
    } else {
      setMinDate(null);
      setMaxDate(null);
    }
  }, [dateRangePicTreeMinMax]);

  useEffect(() => {
    const isEndDateAfterToday = moment(today).isBefore(dateRangePicTreeNttFt[1]);
    const dateRangeValue = isEndDateAfterToday ? [dateRangePicTreeNttFt[0], todayFormatted] : dateRangePicTreeNttFt;
    setDateRangeValue(dateRangeValue);
  }, [dateRangePicTreeNttFt]);

  const handleHomeCalendar = (currentJstDate) => {
    setDateRangeValue(dateRangePicTreeNttFt);
  };

  const setRange = (newValue) => {
    const startDate = moment(newValue[0]).format("YYYY-MM-DD");
    const endDate = moment(newValue[1]).format("YYYY-MM-DD");
    setDateRangePicTreeNttFt([startDate, endDate]);
    setDateRangeValue([startDate, endDate]);
  };

  const fetchData = () => {
    if (currentPage === "/game/pictree/ntt-ft/checkin") {
      getHomePictreeCheckInNttFt();
      getPictreeDataCheckInTrendNttFt(pictreeChartSize);
    } else if (currentPage === "/game/pictree/ntt-ft/photos/overview") {
      getHomePictreePhotoShootNttFt();
      getPictreeDataPhotoShootTrendNttFt(pictreeChartSize);
    } else if (currentPage === "/game/pictree/ntt-ft/photos/map") {
      getPhotoShootMapDataNttFt({ type: "denchu", filter: pictreeMapType });
    } else if (currentPage === "/game/pictree/ntt-ft/photos/asset-type") {
      getPictreePhotoShootByAssetNttFt(pictreeChartSize);
      getPictreePhotoShootTrendByAssetNttFt(pictreeChartSize);
    } else if (currentPage === "/game/pictree/ntt-ft/report/overview") {
      getHomePictreeReportStats("ntt-ft");
      getPictreeDataReportTrend("ntt-ft");
    } else if (currentPage === "/game/pictree/ntt-ft/report/report-by-user") {
      getPictreeDataReportByUser("ntt-ft");
    } else if (currentPage === "/game/pictree/ntt-ft/photos/by-area") {
      getByAreaData("ntt-ft");
    } else if (currentPage === "/game/pictree/ntt-ft/budget") {
      getBudgetSummaryData({ companyCode: "ntt-ft" });
      getBudgetRemainTrendData({ companyCode: "ntt-ft" });
    }
  };

  return (
    <div className={classes.calendarWrapper}>
      <div className={classes.root}>
        <div className={classes.sectionCalendar}>
          <div className={classes.picTreePredefined}>
            <PeriodNttFt
              singlePeriod
            />
          </div>
          <DateRangePicker
            startText="Start"
            endText="End"
            disableHighlightToday={true}
            showToolbar={false}
            allowSameDateSelection={true}
            minDate={minDate}
            maxDate={maxDate}
            value={dateRangeValue}
            onChange={(newValue) => setRange(newValue)}
            onError={([startReason, endReason], [start, end]) => {
              if (startReason === "invalidRange") {
                setError([null, null]);
                return;
              }
              setError([startReason, endReason]);
            }}
            renderInput={(startProps, endProps) => (
              <div className={classes.container}>
                <TextField
                  id="standard-basic"
                  {...startProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                />
                <DateRangeDelimiter>
                  <span className={classes.delimiter}>~</span>
                </DateRangeDelimiter>
                <TextField
                  id="standard-basic"
                  {...endProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                />
              </div>
            )}
          />
          <Button
            className={classes.dataBtn}
            variant="contained"
            color="primary"
            onClick={() => fetchData()}
            disabled={false}
          >
            GO
          </Button>
        </div>
      </div>
    </div>
  );
};

CalendarRangePicTreeNttFt.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  btnStateDataFetch: state.page.btnStateDataFetch,
  dateRangePicTreeNttFt: state.page.dateRangePicTreeNttFt,
  dateRangePicTreeMinMax: state.page.dateRangePicTreeMinMax,
  currentPage: state.page.currentPage,
  pictreeView: state.pictree.pictreeView,
  pictreeChartSize: state.pictree.chartSize,
  pictreeMapType: state.pictree.mapType,
  selectedSeason: state.pictreeNttFt.selectedSeason,
});

const mapDispatchToProps = (dispatch) => ({
  setDateRangePicTreeNttFt: (param) => dispatch(setDateRangePicTreeNttFt(param)),
  getHomePictreeCheckInNttFt: (param) => dispatch(getHomePictreeCheckInNttFt(param)),
  getHomePictreePhotoShootNttFt: (param) => dispatch(getHomePictreePhotoShootNttFt(param)),
  getPictreeDataCheckInTrendNttFt: (param) => dispatch(getPictreeDataCheckInTrendNttFt(param)),
  getPictreeDataPhotoShootTrendNttFt: (param) => dispatch(getPictreeDataPhotoShootTrendNttFt(param)),
  getPictreeDataPhotoDenchuKaisuTrend: (param) => dispatch(getPictreeDataPhotoDenchuKaisuTrend(param)),
  getInGameItemSalesByOccurrence: (param) => dispatch(getInGameItemSalesByOccurrence(param)),
  getPhotoShootMapDataNttFt: (param) => dispatch(getPhotoShootMapDataNttFt(param)),
  getPictreePhotoShootByAssetNttFt: (param) => dispatch(getPictreePhotoShootByAssetNttFt(param)),
  getPictreePhotoShootTrendByAssetNttFt: (param) => dispatch(getPictreePhotoShootTrendByAssetNttFt(param)),
  getHomePictreeReportStats: (param) => dispatch(getHomePictreeReportStats(param)),
  getPictreeDataReportTrend: (param) => dispatch(getPictreeDataReportTrend(param)),
  getPictreeDataReportByUser: (param) => dispatch(getPictreeDataReportByUser(param)),
  getByAreaData: (param) => dispatch(getByAreaData(param)),
  getBudgetSummaryData: (param) => dispatch(getBudgetSummaryData(param)),
  getBudgetRemainTrendData: (param) => dispatch(getBudgetRemainTrendData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(CalendarRangePicTreeNttFt));
